"use strict";
exports.__esModule = true;
var validateCompound = function () {
    var errors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        errors[_i] = arguments[_i];
    }
    for (var _a = 0, errors_1 = errors; _a < errors_1.length; _a++) {
        var error = errors_1[_a];
        if (error.length > 0) {
            return error;
        }
    }
    return '';
};
exports["default"] = validateCompound;
